import React, { useState, Fragment } from 'react';
import Lightbox from 'react-image-lightbox';

import { getTranslatedString } from 'helpers/i18n';

import {
  StyledViewDelete,
  StyledFileContainer,
  StyledImagePreview,
  StyledViewPDFLink,
  StyledFileName,
  StyledImg,
  StyledIcon,
} from './SingleFileUpload.styles';

export const FilePreview = ({ file, removeFile, disabled }) => {
  const [filePreviewOpen, setFilePreviewOpen] = useState(false);

  let filePreview = file;
  // Check if photo is incoming v.s. in S3
  if (file && file.preview) {
    filePreview = file.preview;
  }

  return (
    <Fragment>
      {filePreviewOpen && (
        <Lightbox onCloseRequest={() => setFilePreviewOpen(false)} mainSrc={filePreview} />
      )}

      <StyledFileContainer>
        <StyledImagePreview>
          {file.type !== 'application/pdf' && <StyledImg src={filePreview} />}
          {file && file.name && <StyledFileName>{file.name}</StyledFileName>}
        </StyledImagePreview>
        {file.type === 'application/pdf' ? (
          <StyledViewPDFLink target="_blank" href={filePreview}>
            {getTranslatedString('view')}
          </StyledViewPDFLink>
        ) : (
          <StyledViewDelete type="button" onClick={() => setFilePreviewOpen(true)}>
            {getTranslatedString('view')}
          </StyledViewDelete>
        )}
        {!disabled && (
          <StyledViewDelete type="button" onClick={removeFile(file)}>
            <StyledIcon type="delete" />
          </StyledViewDelete>
        )}
      </StyledFileContainer>
    </Fragment>
  );
};
